import { render } from "./Content.vue?vue&type=template&id=95ce0952&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=95ce0952&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95ce0952"

export default script